import { apiKeyInfoURL, apiKeyUrl, apiToken } from "../config";

export const generateApiKey = async () => {
    try {
        const response = await fetch(apiKeyUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`,
            }
        })
        const data = await response.json();
        if (!response.ok) {
            throw new Error(data.message || "Failed to generate API key");
        }
        return data;
    } catch (error) {
        throw new Error("Failed to generate API key: " + error.message);
    }
}

// start info api

export const getApiKeyInfo = async () => {
    try {
        const response = await fetch(apiKeyInfoURL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`,
            }
        })
        const data = await response.json();
        if (!response.ok) {
            throw new Error(data.message || "Failed to fetch API key info");
        }   
        return data;
    } catch(e) {
        throw new Error("Failed to fetch API key info: " + e.message);
    }
}

// end info api